import React from 'react'
import { Route } from 'react-router-dom'

import styles from './Tabs.module.css'

const TabPanel = ({ children, component: Component, ...rest }) => {
  return (
    <Route {...rest}>
      <div className={styles.tabPanel}>
        {Component && <Component />}
        {children}
      </div>
    </Route>
  )
}

export default TabPanel
